/**
 * @voltxampere/engine — ERC rule: unconnected-pin (Sprint 56)
 *
 * Component declared in the netlist but with one or more terminals
 * NOT referencing any net (or referencing a net with no other pin
 * — the orphan case is covered separately by floating-node rule).
 *
 * Distinct from floating-node: floating-node fires per NET with
 * exactly 1 terminal; unconnected-pin fires per COMPONENT TERMINAL
 * whose `netId` is absent or points at a non-existent net.
 *
 * The Zod schema layer rejects terminal entries with empty netId
 * (Sprint 1+ validation), so this rule mainly catches dangling
 * references — `netId` points at a net that was deleted but the
 * component still references it.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export const unconnectedPinRule = {
    id: "unconnected-pin",
    defaultSeverity: "error",
    requiresDCResult: false,
    check(circuit) {
        const violations = [];
        const knownNetIds = new Set(circuit.nets.map((n) => n.id));
        for (const c of circuit.components) {
            for (const t of c.terminals) {
                if (!knownNetIds.has(t.netId)) {
                    violations.push({
                        ruleId: "unconnected-pin",
                        severity: "error",
                        i18nKey: "erc.unconnected-pin.message",
                        suggestionKey: "erc.unconnected-pin.suggestion",
                        meta: {
                            componentId: c.id,
                            componentType: c.type,
                            terminalId: t.terminalId,
                            danglingNetId: t.netId,
                        },
                    });
                }
            }
        }
        return violations;
    },
};
//# sourceMappingURL=unconnected-pin.js.map